export default "__VITE_ASSET__02979834__"